import { Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { useNotificationCounts } from "@/hooks/useNotifications";

/** Topbar inbox bell with an unread-count pill. The workspace launcher —
 * opens the Maxwell Inbox. Gated behind the `notifications` feature at the
 * call site. */
export function InboxBell() {
  const navigate = useNavigate();
  const { data } = useNotificationCounts();
  const unread = data?.unread ?? 0;

  return (
    <Button
      variant="ghost"
      size="icon"
      className="relative"
      aria-label={unread > 0 ? `Inbox, ${unread} unread` : "Inbox"}
      onClick={() => navigate("/maxwell/inbox")}
    >
      <Bell size={16} />
      {unread > 0 && (
        <span className="absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-xs font-medium leading-none text-primary-foreground">
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </Button>
  );
}
